import React from 'react';
import config from '../../config';
import { twitterPageURL } from '../../util/urlHelpers';
import { StaticPage, TopbarContainer } from '../../containers';
import {
  LayoutSingleColumn,
  LayoutWrapperTopbar,
  LayoutWrapperMain,
  LayoutWrapperFooter,
  Footer,
} from '../../components';

import { FormattedMessage, injectIntl } from '../../util/reactIntl';

import css from './AboutPage.module.css';
import image from './About-us-banner.png';
import useMarketplaceConfigByLocation from '../../util/hooks/useMarketplaceConfigByLocation';
import { intl } from '../../util/reactIntl';
import { ABOUT_PAGE_CONTENT_SWEDEN, ABOUT_PAGE_CONTENT, ABOUT_PAGE_CONTENT_FINLAND } from './data';
import { compose } from 'redux';

const AboutPageComponent = props => {
  const { intl } = props;
  const { siteTwitterHandle, siteFacebookPage } = config;
  const siteTwitterPage = twitterPageURL(siteTwitterHandle);
  const { currentCountryCode } = useMarketplaceConfigByLocation;

  const contents =
    currentCountryCode === 'FI'
      ? ABOUT_PAGE_CONTENT_FINLAND
      : currentCountryCode === 'SE'
      ? ABOUT_PAGE_CONTENT_SWEDEN
      : ABOUT_PAGE_CONTENT;

  const title = intl.formatMessage({ id: 'AboutPage.pageTitle' });
  const description = intl.formatMessage({ id: 'AboutPage.pageDescription' });
  return (
    <StaticPage
      title={title}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutPage',
        description: description,
        name: title,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer />
        </LayoutWrapperTopbar>

        <LayoutWrapperMain className={css.staticPageWrapper}>
          <h1 className={css.pageTitle}>
            <FormattedMessage id="AboutPage.title" />
          </h1>
          <img className={css.coverImage} src={image} alt="My first ice cream." />

          <div className={css.contentWrapper}>
            <p className={css.headText}>
              <FormattedMessage
                id="AboutPage.description"
                values={{ breakline: <div className={css.breakline} /> }}
              />
            </p>
            {contents.map(i => (
              <div key={i.id} className={css.aboutItem}>
                <h2 className={css.itemTitle}>{i.title}</h2>
                <p className={css.itemDescription}>{i.content}</p>
              </div>
            ))}
          </div>
        </LayoutWrapperMain>

        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </StaticPage>
  );
};

const AboutPage = compose(injectIntl)(AboutPageComponent);

export default AboutPage;
